// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1rV-2","infoBtn":"quickbooks_infoBtn__3VFxX","formBox":"quickbooks_formBox__1Oilf","formFooter":"quickbooks_formFooter__2e3MS"};